require('./earlyCancelSimulationView.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { List } = require('immutable');
// @ components
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const { OKCover } = require('commonsComponents/OKCover');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
// @utilities
const classNames = require('classnames');
const currencyHelper = require('utilities/currencyHelper');
// @constants
const {
    IDLE,
    FETCHING,
    FETCHED,
    FETCH_FAILED,
} = require('constants/contactCenter/depositOrImpositionCancellationStatus');
const { DEPOSIT_INTERVENTION_OWNER } = require('constants/index');

class EarlyCancelSimulationView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentWillMount() {
        if (!this.props.immDeposits.has('byId')) {
            this.props.requestDeposits();
        } else {
            this.requestInformation(this.props);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.immDeposits.has('byId')
            && nextProps.immDeposits.has('byId')
        ) {
            this.requestInformation(nextProps);
        }
    }

    requestInformation(props) {
        const {
            match: { params: { depositId, impositionId } },
            requestInterveners,
            queryImpositionEarlyCancellationData,
            immDeposits
        } = props;

        const immDeposit = immDeposits.getIn(['byId', depositId]);
        if (immDeposit) {
            if (!immDeposit.getIn(['interveners', 'list'])) {
                requestInterveners(depositId);
            }
        }

        queryImpositionEarlyCancellationData(depositId, impositionId);
    }

    buildTextValueBox(text, value, rowClassNamePrefix, customRowClassModifier) {
        let rowClasses = [`${rowClassNamePrefix}__detail`];
        if (!!customRowClassModifier) {
            rowClasses.push(`${rowClassNamePrefix}__detail--${customRowClassModifier}`);
        }
        const rowClassName = classNames(rowClasses);
        const textClassName = classNames(`${rowClassNamePrefix}__detail-text`);
        const valueClassName = classNames(`${rowClassNamePrefix}__detail-value`);

        return (
            <div className={rowClassName}>
                <div className={textClassName}>
                    {text}
                </div>
                <div className={valueClassName}>
                    {value}
                </div>
            </div>
        );
    }

    getDataFromServices(props) {
        const {
            match: { params: { depositId, impositionId } },
            queryImpositionEarlyCancellationData
        } = props;

        queryImpositionEarlyCancellationData(depositId, impositionId);
    }

    buildDepositImpositionEarlyCancelSimulation() {
        const { immImpositionEarlyCancellationData } = this.props;
        const status = immImpositionEarlyCancellationData.get('status');
        const immError = immImpositionEarlyCancellationData.get('error');

        let simulationBox;
        switch (status) {
            case IDLE:
            case FETCHING:
                simulationBox = this.buildDepositImpositionEarlyCancelSimulation_fetching();
                break;
            case FETCHED:
                simulationBox = this.buildDepositImpositionEarlyCancelSimulation_success();
                break;
            case FETCH_FAILED:
                simulationBox = this.buildDepositImpositionEarlyCancelSimulation_failure(immError.get('description'));
                break;
        }

        return simulationBox;
    }

    buildDepositImpositionEarlyCancelSimulation_fetching() {
        return (
            <OKSectionBox>
                <LoadingSection />
            </OKSectionBox>
        );
    }

    buildDepositImpositionEarlyCancelSimulation_failure(error) {
        return (
            <OKSectionBox className="imposition-early-cancel-view__content">
                {error}
            </OKSectionBox>
        );
    }

    buildDepositImpositionEarlyCancelSimulation_success() {

        const {
            match: { params: { depositId, impositionId } },
            immImpositionEarlyCancellationData,
            immDeposits,
            immAccounts,
        } = this.props;

        const rowClassNamePrefix = 'imposition-early-cancel-simulation-view';
        const immDeposit = immDeposits.getIn(['byId', depositId]);

        let sectionContent = this.buildDepositImpositionEarlyCancelSimulation_fetching();
        if (!immDeposit.get('isFetching')) {
            const immImposition = immDeposit.getIn(['impositionList', 'byId', impositionId]);
            const immCancellationData = immImpositionEarlyCancellationData.getIn(['impositionEarlyCancellation', 'methodResult']);
            const immInterveners = immDeposit.getIn(['interveners', 'list']) || List();
            const holders = immInterveners
                .filter(intervener => intervener.get('type') === DEPOSIT_INTERVENTION_OWNER)
                .map(intervener => intervener.get('name'))
                .join(' - ');

            const accountContractNumber = immDeposit.getIn(['impositionAssociatedAccount', 'contractNumber'])
            const accountProduct = immDeposit.getIn(['impositionAssociatedAccount', 'product'])
            const immAccount = immAccounts
                .get('byId')
                .filter(immAccount => (immAccount.get('contractNumber') == accountContractNumber && immAccount.get('product') == accountProduct))
                .first();

            const amount = immImposition.get('amount');
            const tae = immCancellationData.get('tasaInteresesAlHaberATASAPL');
            const taePercentage = tae;
            const taeFee = amount * (taePercentage / 100);
            const formattedTaeFee = currencyHelper.formatAmount(taeFee);
            const penalty = immCancellationData.get('tasaFinalATASAFIN');
            const penaltyPercentage = penalty;
            const penaltyFee = amount * (penaltyPercentage / 100);
            const formattedPenaltyFee = currencyHelper.formatAmount(penaltyFee);
            const currency = immImposition.get('currency');
            const expirationDate = immImposition.get('expirationDate');
            const accountNumber = immAccount ? immAccount.get('iban') : '';
            const contractNumber = immDeposit.getIn(['contract', 'fullContractNumber']).trim();
            const holder = holders;
            const total = currencyHelper.formatAmount(taeFee + penaltyFee);

            const impositionPath = `/myprofile/deposits/${depositId}/imposition/${impositionId}`;
            const impositionEarlyCancelPath = `/myprofile/deposits/${depositId}/imposition/${impositionId}/early-cancel`;

            const amountBox = this.buildTextValueBox(
                formatText('earlyCancelSimulation-amount'),
                `${amount} ${currency}`, rowClassNamePrefix
            );
            const taeBox = this.buildTextValueBox(
                formatText('earlyCancelSimulation-tae'),
                `${taePercentage}% = ${formattedTaeFee} ${currency}`, rowClassNamePrefix
            );
            const penaltyBox = this.buildTextValueBox(
                formatText('earlyCancelSimulation-penalty'),
                `${penaltyPercentage}% = ${formattedPenaltyFee} ${currency}`, rowClassNamePrefix
            );
            const totalBox = this.buildTextValueBox(
                formatText('earlyCancelSimulation-total'),
                `${total} ${currency}`, rowClassNamePrefix, 'total'
            );
            const impositionNumberBox = this.buildTextValueBox(
                formatText('earlyCancelSimulation-impositionNumber'),
                impositionId, rowClassNamePrefix
            );
            const expirationDateBox = this.buildTextValueBox(
                formatText('earlyCancelSimulation-expirationDate'),
                expirationDate, rowClassNamePrefix
            );
            const accountNumberBox = this.buildTextValueBox(
                formatText('earlyCancelSimulation-accountNumber'),
                accountNumber, rowClassNamePrefix
            );
            const contractNumberBox = this.buildTextValueBox(
                formatText('earlyCancelSimulation-contractNumber'),
                contractNumber, rowClassNamePrefix
            );
            const holderBox = this.buildTextValueBox(
                formatText('earlyCancelSimulation-holder'),
                holder, rowClassNamePrefix
            );

            sectionContent = (
                <OKSectionBox>
                    <h1 className="imposition-early-cancel-simulation-view__title">
                        <FormattedText value="earlyCancelSimulation-title" />
                    </h1>
                    <div className="row">
                        <div className="col-xs-6">
                            <div className="imposition-early-cancel-simulation-view__column-content">
                                {amountBox}
                                {taeBox}
                                {penaltyBox}
                                {totalBox}
                            </div>
                        </div>
                        <div className="col-xs-6">
                            <div className="imposition-early-cancel-simulation-view__column-content">
                                {impositionNumberBox}
                                {expirationDateBox}
                                {accountNumberBox}
                                {contractNumberBox}
                                {holderBox}
                            </div>
                        </div>
                    </div>
                    <footer className="imposition-early-cancel-simulation-view__buttons">
                        <div className="imposition-early-cancel-simulation-view__first-button">
                            <OKButton
                                modifier="link-ghost"
                                to={impositionPath}
                            >
                                <FormattedText value="common-cancel" />
                            </OKButton>
                        </div>
                        <div className="imposition-early-cancel-simulation-view__last-button">
                            <OKButton
                                modifier="secondary"
                                to={impositionEarlyCancelPath}
                            >
                                <FormattedText value="earlyCancelSimulation-cancelImposition" />
                            </OKButton>
                        </div>
                    </footer>
                </OKSectionBox>
            );
        } else {
            sectionContent = this.buildDepositImpositionEarlyCancelSimulation_failure('No se ha cargado la imposición');
        }

        return sectionContent;
    }

    render() {
        const simulation = this.buildDepositImpositionEarlyCancelSimulation();

        return (
            <div className="imposition-early-cancel-simulation-view">
                <OKCover size="small" section="deposits">
                    <OKHeaderLanding title="Depositos" inputClassName="ok-header-landing--deposits" />
                </OKCover>
                <div className="imposition-early-cancel-simulation-view__body">
                    <div className="row no-outside-gutter">
                        {simulation}
                    </div>
                </div>
            </div>
        );
    }
}

EarlyCancelSimulationView.propTypes = {
    immImpositionEarlyCancellationData: PropTypes.object.isRequired,
    queryImpositionEarlyCancellationData: PropTypes.func,
    immDeposits: PropTypes.object.isRequired,
    requestDeposits: PropTypes.func.isRequired,
    requestInterveners: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
};

module.exports = EarlyCancelSimulationView;
